import { Platform } from 'quasar';

// eslint-disable-next-line import/prefer-default-export
export const usePlatform = () => Platform;
